import * as classes from "./ar-quick-view-button.module.scss";
import { useCallback, useEffect, useRef, useState } from "react";
import ARIcon from "../../icons/AR.svg";
// constants to check for various platforms / AR subsytems support
// @see https://github.com/google/model-viewer/blob/master/packages/model-viewer/src/features/ar.ts
const IS_ANDROID = /android/i.test(navigator.userAgent);
const IS_IOS =
  (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

const IS_SAFARI = /Safari\//.test(navigator.userAgent);
const IS_FIREFOX = /firefox/i.test(navigator.userAgent);
const IS_OCULUS = /OculusBrowser/.test(navigator.userAgent);
const IS_IOS_CHROME = IS_IOS && /CriOS\//.test(navigator.userAgent);
const IS_IOS_SAFARI = IS_IOS && IS_SAFARI;

const SUPPORTS_SCENEVIEWER = IS_ANDROID && !IS_FIREFOX && !IS_OCULUS;
const SUPPORTS_QUICKLOOK = (() => {
  const anchor = document.createElement("a");
  return (
    anchor.relList && anchor.relList.supports && anchor.relList.supports("ar")
  );
})();

enum Mode {
  "QuickLook",
  "SceneViewer",
}

const ARQuickViewButton = ({
  title,
  src,
  iosSrc,
}: {
  title: string;
  src: string;
  iosSrc: string;
}) => {
  const elRef = useRef();
  const [isSupported, setIsSupported] = useState<boolean | null>(null);
  const [href, setHref] = useState("");
  const [mode, setMode] = useState<Mode | null>(null);

  useEffect(() => {
    if ((IS_IOS_CHROME || IS_IOS_SAFARI) && SUPPORTS_QUICKLOOK) {
      setIsSupported(true);
      setHref(iosSrc);
      setMode(Mode.QuickLook);
    } else if (SUPPORTS_SCENEVIEWER) {
      setIsSupported(true);
      setHref(
        `intent://arvr.google.com/scene-viewer/1.0?file=${src}&mode=ar_only&title=${encodeURIComponent(
          title
        )}#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;`
      );
      setMode(Mode.SceneViewer);
    } else {
      setIsSupported(false);
    }
  }, []);

  const onClick = useCallback(() => {
    const anchor = document.createElement("a");

    if (mode === Mode.QuickLook) {
      anchor.appendChild(document.createElement("img"));
      anchor.rel = "ar";
    }

    anchor.setAttribute("href", href);
    anchor.click();
  }, [href, mode]);

  if (isSupported === false) return null;
  return (
    <button
      className={classes.root}
      ref={elRef}
      onClick={onClick}
      aria-label="View in AR"
    >
      <ARIcon />
      See it in your world
    </button>
  );
};
export default ARQuickViewButton;
